import { TimeClock } from '../../components/TimeClock';

export default function FieldTime() {
  return <div className="space-y-6"><h1 className="font-head text-4xl font-black text-white">Time</h1><TimeClock /></div>;
}
